module.exports = __webpack_public_path__ + "img/topup-icon.9c537c97.svg";